import React, { useEffect } from "react";

import { CONTACT_TYPE_OPTIONS } from "../model/addContact.constants";
import { AddContactType } from "../model/addContact.types";
import { ContactTypeCard } from "./ContactTypeCard";

type AddContactTypeSelectionProps = {
  onSelectType: (type: AddContactType) => void;
  onClose: () => void;
};

export const AddContactTypeSelection: React.FC<
  AddContactTypeSelectionProps
> = ({ onSelectType, onClose }) => {
  // Esc closes the chooser even when the box that opened it (e.g. the search
  // dropdown) keeps the key to itself (QA batch 16, NAV-009).
  useEffect(() => {
    const onKey = (event: KeyboardEvent) => {
      if (event.key === "Escape") onClose();
    };
    window.addEventListener("keydown", onKey, true);
    return () => window.removeEventListener("keydown", onKey, true);
  }, [onClose]);

  return (
    <div className={"relative"}>
      <button
        type={"button"}
        className={
          "close-popup absolute -right-2 -top-2 flex h-4 w-4 cursor-pointer items-center justify-center"
        }
        onClick={onClose}>
        <img src={"/img/closse.png"} alt={"Close"} />
      </button>

      <div className={"mb-8 pr-8"}>
        <h2 className={"text-[18px] font-semibold text-[#111827]"}>
          Choose contact type
        </h2>
        <p className={"mt-2 text-[14px] font-medium text-gray-500"}>
          Select the type that best describes this contact
        </p>
      </div>

      <div className={"mb-6 grid grid-cols-2 gap-4"}>
        {CONTACT_TYPE_OPTIONS.map((option) => (
          <ContactTypeCard
            key={option.type}
            type={option.type}
            title={option.title}
            description={option.description}
            onSelect={onSelectType}
          />
        ))}
      </div>
    </div>
  );
};
